export default __webpack_public_path__ + "static/media/Accueil.1c3f092f.svg";